module.exports = {
      id: "youtube-plain-color-usage",
      viewBox: "0 0 30 21",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#youtube-plain-color",
      toString: function () {
        return this.url;
      }
    }